<h1>Links to great guitar learning resources</h1>

<ul>
  <li>
    Marty Schwartz is an awesome teacher and also has some fun non-educational videos. <a
      href="https://www.youtube.com/c/martymusic">Here</a> is his Youtube channel.
  </li>

  <li>
    Justin Sandercoe is another great teacher and is especially helpful if you are a
    beginner guitarist. Check out his <a href="https://www.youtube.com/c/justinguitar"
      >channel</a
    >.
  </li>

  <li>
    <a href="https://www.youtube.com/c/PaulDavids">Paul Davids</a> is more for entertainment
    than for learning, but he often breaks down stuff for his viewers and is a great player.
  </li>

  <li>
    <a href="https://www.youtube.com/c/EpicGuitarInstruction">Epic Guitar Instruction</a> is
    also a great channel for beginners. Tons of easy to follow tutorials for the beginning
    and intermediate guitar player.
  </li>

  <li>
    <a href="https://www.youtube.com/c/RickBeato">Rick Beato</a> is like Paul Davids more for
    entertainment than for learning, but he offers some great content, like breaking down song
    structures and explaining why they work.
  </li>

  <li>
    If you are from <em>Germany</em>, make sure to check out Till from
    <a href="https://www.youtube.com/c/GitarrentunesDe">GitarrenTunes</a>, probably the
    best youtube teacher who speaks German.
  </li>

  <li>
    The same goes for the spanish speaking crowd, check out <a
      href="https://www.youtube.com/c/cifraclub">Cifra Club</a
    >.
  </li>
</ul>

<style type="text/scss">
  li {
    margin: 1rem 0;
  }
</style>
